var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSubscription(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 27,
    viewBox: "0 0 25 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.57143 0V2.34783H2.38095C1.07143 2.34783 0 3.40435 0 4.69565V21.1304C0 22.4217 1.07143 23.4783 2.38095 23.4783H8.54957C8.41267 22.9124 8.33333 22.3243 8.33333 21.7174C8.33333 21.5167 8.37366 21.3265 8.38914 21.1304H2.38095V8.21739H19.0476V11.8492C19.4369 11.7834 19.8333 11.7391 20.2381 11.7391C20.644 11.7391 21.0405 11.78 21.4286 11.8446V4.69565C21.4286 3.40435 20.3571 2.34783 19.0476 2.34783H17.8571V0H15.4762V2.34783H5.95238V0H3.57143ZM20.2381 14.087C18.5202 14.087 16.9595 15.0072 16.1203 16.4394C16.1036 16.4394 16.0881 16.4348 16.0714 16.4348C13.1179 16.4348 10.7143 18.8049 10.7143 21.7174C10.7143 24.6299 13.1179 27 16.0714 27C18.4298 27 20.412 25.4808 21.1263 23.3888C23.3275 22.9768 25 21.0717 25 18.7826C25 16.193 22.8643 14.087 20.2381 14.087ZM16.0714 18.7826C17.7131 18.7826 19.0476 20.0997 19.0476 21.7174C19.0476 23.335 17.7131 24.6522 16.0714 24.6522C14.4298 24.6522 13.0952 23.335 13.0952 21.7174C13.0952 20.0997 14.4298 18.7826 16.0714 18.7826Z",
    fill: "#0044c6 "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubscription);
export default __webpack_public_path__ + "static/media/Subscription.4462c13db8f95b2a6591f6fb2ab7a067.svg";
export { ForwardRef as ReactComponent };